export default {
  firstTip: '于申请开通结构性产品交易前，请先详细阅读',
  linkTitle: '「结构性产品相关风险声明披露」',
  lastTip: '，并观看香港交易所网站的股票期权教育短片。',
  languageVideo: '短片语言',
  pdfLink: 'http://download.eddidapp.com/pdf/SC/risks-of-structured-products-disclosure-statement.pdf',
  yyType: '粤语版',
  ptType: '普通话版',
  problems: [{
    title: '1.简介香港交易所网站的股票期权专页',
    quTitle: '本片将重点讲解：',
    // 简体，繁体
    src: ['http://download.eddidapp.com/video/SC/Simplified1.mp4', 'http://download.eddidapp.com/video/TC/Traditional1.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video1.jpg?la=zh-HK&hash=060F2AB3B8649FF23E3315EDA28EBA1CC28C31BD',
    content: [
      '• 香港交易所期权专页如何能协助您建构投资策略？ ',
      '• 新增的十个期权工具是什么？ '
    ]
  }, {
    title: '2.如何用股票期权复制Bull ELN ',
    quTitle: '本片将重点讲解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified2.mp4', 'http://download.eddidapp.com/video/TC/Traditional2.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/course1_tc.jpg?la=zh-HK&hash=0D2A99403414776974EF429C79967E0B0F8AF602',
    content: [
      '• 什么是Bull ELN？ ',
      '• 投资者可以如何运用交易所买卖的股票期权以达到相同的回报？ ',
      '• 这个投资策略适合什么类型的投资者？ '
    ]
  }, {
    title: '3.透过股票期权提高收入',
    quTitle: '本片将重点讲解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified3.mp4', 'http://download.eddidapp.com/video/TC/Traditional3.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/course2_tc.jpg?la=zh-HK&hash=09956EE25354CC749735C96939B6B4226317584F',
    content: [
      '• 如果你已持有一只股票，除每年获发数次股息外，你可怎样运用交易所买卖的股票期权以提高回报呢？ '
    ]
  }, {
    title: '4. 期权买卖–场内还是场外交易?',
    quTitle: '本片将重点讲解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified4.mp4', 'http://download.eddidapp.com/video/TC/Traditional4.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video2.jpg?la=zh-HK&hash=4BB39BC4DC6DCF4C55733ED562D54D2C856CDE6A',
    content: [
      '• 场内及场外交易有什么不同? ',
      '• 两种交易平台的好处及坏处是什么? '
    ]
  }, {
    title: '5.引申波幅',
    quTitle: '本片将重点讲解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified5.mp4', 'http://download.eddidapp.com/video/TC/Traditional5.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video3.jpg?la=zh-HK&hash=8EE76EB26E9731715D6C4F2BD9BD610D21D5FE37',
    content: [
      '• 什么是引申波幅?',
      '• 投资者可怎样比较不同行使价的期权的价格? '
    ]
  }, {
    title: '6. 寻找期权报价',
    quTitle: '本片将重点讲解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified6.mp4', 'http://download.eddidapp.com/video/TC/Traditional6.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video4.jpg?la=zh-HK&hash=65CD0D59646534F57F34291BB3F9545E3EEE1A5C',
    content: [
      '• 如何获得股票期权报价? ',
      '• 要求报价功能 '
    ]
  }, {
    title: '7. 期权买卖差价解读',
    quTitle: '本片将重点讲解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified7.mp4', 'http://download.eddidapp.com/video/TC/Traditional7.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video5.jpg?la=zh-HK&hash=E79BAE96C58EBFDC538F8FB9462A3551B5C4DB1E',
    content: [
      '• 什么是买卖差价? ',
      '• 有什么因素影响股票期权买卖差价? '
    ]
  }, {
    title: '8. 期权为投资组合带来的好处',
    quTitle: '本片将重点讲解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified8.mp4', 'http://download.eddidapp.com/video/TC/Traditional8.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video6.jpg?la=zh-HK&hash=7819DCFF7DABE3423C56059F781E277C6665C318',
    content: [
      '• 什么是杠杆效应? ',
      '• 什么是增进收益率? '
    ]
  }],
  firstReadTip: '于申请开通结构性产品交易前, 请先详细阅读',
  lastReadTip: '',
  firstCheckTip: '本人欲买卖衍生品权证、牛熊证及结构性产品及本人特此确认，本人已明白买卖衍生权证、牛熊证及结构性产品的风险并已详细阅读',
  lastCheckTip: '本人确认本人之所有资料与开户时所提交的资料相同',
  btn: '提交申请',
  btn1: '已提交',
  errorChecked: '请确认已详细阅读「结构性产品和香港风险声明披露」',
  submitTip: '您的申请已经成功提交，我们将在3个工作日内进行审核，您可以拨打+852 2655 0338 / 400 120 0068（中国内地免费热线）与我们联系。',
  failureTip: '您的申请已被拒绝，您可以拨打+852 2655 0338 / 400 120 0068（中国内地免费热线）与我们联系，或者重新提交申请。',
  success: '您的结构性交易产品申请已成功提交,如有问题请与我们联系。',
  completedTip: '您的申请已经审核通过，您可以进行结构性产品交易。',
  shenqingTip: '请先申请证券账号',
  errorMsg: {
    '10002': '已经存在结构性申请记录，勿重复提交'
  },
  titleTip: '衍生品相关经验',
  infomationTips1: '本人曾接受有关衍生产品性质和风险的一般知识培训或修读相关课程',
  infomationTips2: '本人在过去3年曾执行5次或以上有关衍生产品的交易，例如：衍生证券、牛熊市、股票期权、期货与期权、商品、结构性产品及交易所买卖基金等',
  infomationTips3: '本人从现在或过去拥有过与衍生产品有关的工作经验',
  notSameInfo: '于申请开通结构性产品交易前，请确认资料是否有更改，如有，请联系客服+852 2655 0338 / 400 120 0068（中国内地免费热线） | 电邮: cs@eddidsec.com',
  oneInfo: '由于您：选择开通结构性产品，必须勾选至少一项衍生品相关经验',
  riskTip: '艾德证券期货已根据以上的资料对客户进行评估，并已通知客户买卖有关衍生产品前必须先具备足够的认识，及提示客户有关衍生产品之性质及风险。',
  hasExchange: '阁下是否曾于过去三年曾执行五次或以上衍生工具的交易，例如：衍生权证、牛熊证、股票期权、期货及期权、结构性产品等？',
  hasWorkExperience: '阁下是否曾经取得衍生工具的工作经验？',
  hasTraining: '阁下是否曾经接受衍生工具的培训或修读相关课程？',
  derivativesCheckedTip: '阁下未能提供相关证明文件，请仔细阅读',
  derivativesCheckedTipLast: '并填写“第二部分 - 衍生工具知识问卷”以完成此评估。',
  derivativesBasicLink: 'https://download.eddidapp.com/pdf/SC/GeneralKnowledgeonDerivativesProducts.pdf',
  derivativesBasic: '「衍生产品基本知识」',
  transactionNotesTitle: '请提供相关文件证明，例如：成交单据、户口结单等等',
  licenseeCardTitle: '请提供相关资料／文件证明，例如：持牌人中央编号名片等',
  certificateTitle: '请提供相关文件证明，例如：证书等',
  uploadProof: '证明文件',
  tradingtime: '交易时间',
  relatedfinancialinstitutions: '相关金融机构',
  producttypes: '产品种类',
  employername: '雇主名称',
  position: '职位',
  yearsofemployment: '工作年期',
  nameoftrainingorcourse: '培训或修读课程的名称',
  dateoftrainingorcourse: '培训或修读以上课程的日期',
  pleaseCheckBasics: '请勾选“阁下未能提供相关证明文件，请仔细阅读「衍生产品基本知识」并填写“第二部分 - 衍生工具知识问卷”以完成此评估。”',
  customerConfirmationTitle: '客户确认及声明',
  derivativesKnowledgeTitle: '衍生工具知识问卷',
  customerConfirmationOne: '本人/吾等确认上述资料完全真实及完整，并明白艾德将根据上述资料评估本人/吾等是否拥有对衍生产品之知识，以符合《证券及期货事务监察委员会持牌人或注册人操守准则》之有关要求。',
  customerConfirmationTwo: '本人/吾等明白于本表格上提供资料为评估本人/吾等对衍生工具的知识是自愿的。倘本人/吾等未能提供有关资料，是次之评估将不获处理。',
  customerConfirmationThree: '本人/吾等已仔细阅读及完全明白，由艾德提供，并以本人/吾等所选择之语言（英文或中文）的 ',
  customerConfirmationFour: '本人/吾等并愿意承担交易相关在交易所买卖的衍生产品所带来的潜在风险。',
  explanatoryNote: '「交易所买卖衍生产品风险说明｣ ',
  explanatoryNoteLink: 'https://download.eddidapp.com/pdf/SC/RisksAssociatedwithDerivativeProducts.pdf',
  customerConfirmationThreeLast: '本人/吾等确认假若本人对该文件有任何疑问，本人/吾等应当寻求独立专业意见。本人/吾等并且确认该文件不能披露投资衍生产品可能涉及的所有风险，与及本人/吾等须就投资这些产品作出本人自己的判断，并确保本人/吾等拥有充分的淨资产以承担风险及潜在的损失。',
  unfinishedReminder: '请完成问卷。',
  exceededlimitTip: '衍生工具知识问卷每日评估次数不能超过两次。阁下可以按 [继续开户申请] 完成余下的开户流程，但在通过衍生工具知识问卷之前，阁下将被禁止进行衍生工具相关的交易。',
  continue: '继续开户申请',
  evaluationResults: '评估结果',
  lackofknowledge: '不具备衍生工具知识',
  exceededtwicelimitTip: '衍生工具知识问卷每日评估次数不能超过两次。如有疑问，请联络客户服务主任。电话：+852 2655 0338 / 400 120 0068（中国内地免费热线） 电邮：cs@eddidsec.com',
  viewResults: '查看结果',
  derivativesKnowledgeResult: '问卷结果',
  jobDuties: '工作职责',
  needCondition: '抱歉，您未开通证券交易账户，无法申请交易结构性产品，如有需要可申请开立证券交易账户。',
  btnReEvaluate: '重新评估',
  agree: '您需要阅读并勾选相关协议'
}
